import React from 'react';
import Image from 'next/image';
import Typography from '@common/Typography';
import Breadcrumb from '@common/Breadcrumb';
import { useRouter } from 'next/router';

const ProductNotFound = (props) => {
    const { t, keyword } = props;
    const router = useRouter();

    const image = '/assets/img/ui-search.svg';
    const isSearchResultPage = router.pathname === '/catalogsearch/result';
    const breadcrumbsData = [
        // {
        //     label: t('cart:pageTitle'),
        //     link: '#',
        //     active: true,
        //     id: '',
        // },
    ];

    return (
        <>
            {isSearchResultPage && (
                <div className="hidden tablet:flex">
                    <Breadcrumb iconHomeOnly data={breadcrumbsData} />
                    <Typography variant="p-3" className="!text-[13px] font-normal leading-6 !text-neutral-150">
                        {t('catalog:title:searchResult')}
                        {' '}
                        &quot;
                        {keyword}
                        &quot;
                    </Typography>
                </div>
            )}

            <div className="flex w-full items-center flex-col mx-auto">
                <Image
                    src={image}
                    width={150}
                    height={150}
                    alt="image product not found"
                    className="my-[30px]"
                />
                <Typography variant="p-3" className="!text-2xl font-bold leading-7 mb-5 text-center">
                    {t('catalog:emptyProductSearchResultHeading', { keyword: keyword ? `"${keyword}"` : '' })}
                </Typography>
                <Typography variant="p-3" className="mb-2.5 !text-base tracking-[.35px] !text-neutral-500 text-center leading-[22px]">
                    {t('catalog:emptyProductSearchResult')}
                </Typography>
            </div>
            <style global jsx>
                {`
                    .swift-product-list-container {
                        max-width: 100%;
                        flex-basis: 100%;   
                    }
                `}
            </style>
        </>
    );
};

export default ProductNotFound;
